export default "__VITE_ASSET__ChZmtDli__"